<div #barclaycardGooglePayButtonContainer></div>
<result [status]="availableStatus"
        [duration]="'permanent'"></result>
